<template>
  <div class="mats-listing__wrapper"
       style="width: 60%"
  >
    <div class="toolbar">
      <div
        v-if="show == true"
        class="toolbar__row"
      >
        <div class="search-filter search-filter--narrow">
          <b-icon-search />
          <input
            v-model="searchInput"
            type="text"
            autocomplete="off"
            name="search-box"
            :placeholder="$t(toggleSearch === 'OrderNumber' ? 'OrderNumber' : 'ClientName')"
            @keyup="inputChanged1"
            @keydown.down="onArrowDown1"
            @keydown.up="onArrowUp1"
          >
          <b-icon-x-circle
            class="search-filter__clear"
            :class="{ 'search-filter__clear--active': searchCN != '' || searchOrder != '' }"
            @click="searchCN = '', searchOrder = ''"
          />
          <b-form-select
            v-model="toggleSearch"
            :options="searchFilterOptions"
          />
          <div
            v-if="filteredResults.length > 0"
            ref="scrollContainer"
            class="search-filter__options"
          >
            <div
              v-for="(result, index) in filteredResults"
              :key="index"
              ref="options"
              :class="{ 'is-active': index === arrowCounter }"
              class="search-filter__option"
              @click="selectResult(result)"
            >
              {{ displayResult(result) }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="width: 100%; margin-top: 0px;">
      <table
        class="team_table"
      >
        <thead>
          <tr>
            <th>
              {{ $t('orderNumber') }}
            </th>
            <th>
              {{ $t('OrderType') }}
            </th>
            <th>
              {{ $t('CustomerName') }}
            </th>
            <th>
              {{ $t('created') }}
            </th>
            <th>
              {{ $t('SalesPerson') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item,index) in getDeliveredOrders"
            :key="index"
            class="hover-row"
            :style="classNameCh === item.orderNumber ? 'background-color: rgba(255, 39, 79, 0.1)' : ''"
            @click="matProps(item)"
          >
            <td>{{ item.orderNumber }}</td>
            <td>{{ $t(item.orderType) }}</td>
            <td>{{ item.customerName }}</td>
            <td>{{ convertUTCDateToLoacalDate(item.created) }}</td>
            <td>{{ item.salesPersonFullName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div></template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment'



export default {
  components: {

  },
  // eslint-disable-next-line vue/require-prop-types
  props: [],
  data() {
    return {
      searchFilterOptions: [
        {
          text: this.$t('ClientName'),
          value: 'ClientName',
        },
        {
          text: this.$t('OrderNumber'),
          value: 'OrderNumber',
        },
      ],
      toggleSarch: false,
      noSearch: false,
      noSearchTwo: false,
      show: true,
      toggleSearch: 'ClientName',
      searchCN: '',
      searchOrder: '',
      page: 1,
      pageSize: 15,
      classNameCh: null,
      arrowCounter: 0,
      enterPressed: false,
      orderState: 'Delivered',
      year: moment().format('YYYY'),
      salesPersonFullName: '',
    }
  },
  computed: {
    ...mapGetters(['getDeliveredOrders', 'getAdminOrders', 'getTotalItemsForOrders', 'getFirstNames', 'getSearchInNewOrders', 'getFilteredOrdersbyCN',
      'getFilteredOrdersbyON']),
    searchInput: {
      get() {
        return this.toggleSearch === 'ClientName' ? this.searchCN : this.searchOrder;
      },
      set(value) {
        if (this.toggleSearch === 'ClientName') {
          this.searchCN = value;
        } else {
          this.searchOrder = value;
        }
      },
    },
    filteredResults() {
      if (this.toggleSearch === 'ClientName') return this.getFilteredOrdersbyCN;
      if (this.toggleSearch === 'OrderNumber') return this.getFilteredOrdersbyON;
      return []
    },
  },
  watch: {
    toggleSearch(newValue) {
      if (newValue === 'OrderNumber') {
        this.searchClient = '';
        this.searchOrderNumber = '';
      } else if (newValue === 'ClientName') {
        this.searchOrderNumber = '';
        this.searchClient = '';
      }
    },
    page(value) {
      this.loadDeliveredOrders({
        orderNumber: null,
        year: this.year,
        clientId: null,
        pageNumber: value,
        pageSize: this.pageSize,
      })
    },
    searchOrder(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value == '') {
          this.removeLists()
          this.loadDeliveredOrders({
            orderNumber: null,
            year: this.year,
            clientId: null,
            pageNumber: this.page,
            pageSize: this.pageSize,
          });
        } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
          return;
        } else {
          this.searchInNewOrders(value);
          this.noSearch = true
        }
      }, 500);
    },
    searchCN(value) {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }
      this.timeoutId = setTimeout(() => {
        if (value == '') {
          this.clientId = null
          this.noSearchTwo = false
          // this.fshijCN();
          this.loadDeliveredOrders({
            orderNumber: null,
            year: this.year,
            clientId: null,
            pageNumber: this.page,
            pageSize: this.pageSize,
          });
        } else if (this.enterPressed) {
        // eslint-disable-next-line no-useless-return
          return
        } else {
          this.firstNames(value);
          this.noSearchTwo = true
        }
      }, 500);
    },
  },
  mounted() {
    this.loadDeliveredOrders({
      orderNumber: null,
      year: this.year,
      clientId: null,
      pageNumber: this.page,
      pageSize: this.pageSize,
    })

    console.log(this.getDeliveredOrders);
  },
  methods: {
    ...mapActions(['loadDeliveredOrders', 'readOrderItems', 'loadCreatedOreders', 'firstNames', 'searchInNewOrders']),
    displayResult(result) {
      if (this.toggleSearch === 'ClientName') return result.nameToDisplay;
      return result;
    },
    selectResult(result) {
      if (this.toggleSearch === 'ClientName') {
        this.searchByCn(result);
      } else if (this.toggleSearch === 'OrderNumber') {
        this.searchByOn(result);
      }
      this.noSearch = false;
    },
    matProps(value) {
      this.classNameCh = value.orderNumber
      this.$emit('setSalesPerson', value.salesPersonFullName);
      console.log('Sales person', value.salesPersonFullName)
      this.readOrderItems({
        orderId: value.orderId,
        orderItemState: null,
      })
    },
    showCustomerName() {
      this.toggleSarch = false;
      this.searchCN = '';
      this.show = true
      this.loadDeliveredOrders({
        orderNumber: null,
        year: this.year,
        clientId: null,
        pageNumber: this.page,
        pageSize: this.pageSize,
      })
    },
    showOrderNumber() {
      this.toggleSarch = true;
      this.searchOrder = '';
      this.show = false;
      this.loadDeliveredOrders({
        orderNumber: null,
        year: this.year,
        clientId: null,
        pageNumber: this.page,
        pageSize: this.pageSize,
      })
    },
    async searchByOn(value) {
      this.searchOrder = value
      this.noSearch = false
      await this.loadDeliveredOrders({
        year: this.year,
        clientId: null,
        pageNumber: this.page,
        pageSize: this.pageSize,
        orderNumber: this.searchOrder,
      })
      this.noSearch = false
      // router.push({ name: 'Orders Management', query: { orderNumber: value } });
      this.noSearch = false
    },
    async searchByCn(value) {
      this.searchCN = value.nameToDisplay
      this.clientId = value.clientId
      this.noSearchTwo = false
      await this.loadDeliveredOrders({
        orderNumber: null,
        year: this.year,
        pageNumber: this.page,
        pageSize: this.pageSize,
        clientId: value.clientId,
      })
      this.noSearchTwo = false
      // router.push({ name: 'Orders Management', query: { clientId: value.nameToDisplay } });
    },
    inputChanged(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // this.getFilteredActiveUsers = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByOn(this.getSearchInNewOrders[this.arrowCounter])
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    fixScrolling() {
      const liH = this.$refs.options[this.arrowCounter].clientHeight;
      console.log(liH)
      this.$refs.scrollContainer.scrollTop = liH * this.arrowCounter;
    },
    onArrowDown1(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getFirstNames.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },
    onArrowUp1(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    inputChanged1(event) {
      if (event.code == 'ArrowUp' || event.code == 'ArrowDown') { return; }
      // this.getFilteredOrdersbyON = [];

      // eslint-disable-next-line no-useless-return
      if (event.code == 'Enter') {
        this.enterPressed = true
        this.searchByCn(this.getFirstNames[this.arrowCounter])
        this.removeLists()
        this.arrowCounter = 0
        setTimeout(() => {
          this.enterPressed = false
        }, 1000)
        // eslint-disable-next-line no-useless-return
        return;
      }
    },
    onArrowDown(ev) {
      ev.preventDefault()
      if (this.arrowCounter < this.getSearchInNewOrders.length - 1) {
        this.arrowCounter += 1;
        this.fixScrolling();
      }
    },

    onArrowUp(ev) {
      ev.preventDefault()
      if (this.arrowCounter > 0) {
        this.arrowCounter -= 1;
        this.fixScrolling()
      }
    },
    removeLists() {
      this.noSearch = false;
      this.resetSearchInNewOrders();
    },
    convertUTCDateToLoacalDate(date) {
      const local = moment.utc(date).local().format('DD-MMM-YYYY h:mm A')
      return local
    },
  },
}
</script>

<style scoped lang="scss">

.team_table td {
  padding: 12px 9px !important;
}

.team_table th {
  // text-align: center;
}

.hover-row:hover {
    background-color: rgba(255, 39, 79, 0.1);
}
.dropdrop {
  display: inline-block;
  overflow: auto;
  position: absolute;
  background: white;
  width: 227px;
  box-shadow: none;
}

input[name="search-box"] {
  display: block;
  max-width: 500px;
  width: 95%;
  padding: 0.5rem 1rem;
  padding-left: 25px;
}
.search-item {
  padding: 5px;
  max-width: 500px;
  width: 100%;
  font-weight: 400;
  color: #82868c;
  font-size: 1rem;
  border-bottom: 1px solid #e8e8e8;
}
.search-item:last-child {
  border-bottom: none;
}
.search-item:hover {
  background: #82868c;
  color: white;
}
.search-item hr {
  color: lightgray;
  border-top: none;
  margin: -1.3rem 0 0.5rem 0;
}
.is-active {
  background-color: #dedede;
}

.editButton {
  height: 30px;
}
.active2 {
  font-weight: bold;
  color: $base-color;
}
.active2{
  color: $base-color;
  font-weight: bold;
}
.hover-row:hover {
    background-color: rgba(255, 39, 79, 0.1);
}
.mats-listing__wrapper {
  .mats-listing{
    margin-top: 0
  }
}
  .button {
    margin-bottom: 15px!important;
  }
  .mat {
    display: flex;
    justify-content: space-between;
    align-content: center;
    &.active {
      background-color: #e8e8e8;
    }
    div {
      display: flex;
      justify-content: space-between;
      align-content: center;
    }
    span {
      margin-left: 10px;
      svg {
        font-size: 15px;
      }
    }
  }
  .team_table {
  font-size: 12px;
  border-radius: 8px 8px 8px 8px !important;
}



table:hover {
  cursor: pointer;
}
.dropdrop::-webkit-scrollbar {
display: none;

}
</style>
